import { UpdatePatientHealthInsurance } from 'domain/usecases/patient/update-patient-health-insurance'
import { PatientRepository } from 'repository/interfaces/patient-repository'

export class RemoteUpdatePatientHealthInsurance
  implements UpdatePatientHealthInsurance
{
  private readonly patientRepository: PatientRepository

  constructor(patientRepository: PatientRepository) {
    this.patientRepository = patientRepository
  }
  update(
    params: UpdatePatientHealthInsurance.Params
  ): Promise<UpdatePatientHealthInsurance.Model> {
    return this.patientRepository.updateHealthInsurance(params)
  }
}

export type UpdatePatientHealthInsuranceModel =
  UpdatePatientHealthInsurance.Model
